import services, {http} from "@/services";
import { toaster } from "@/components/ui/toaster"
import {getStoredUser} from "@/contexts/userContext";

let interceptorsRegistered = false;

export const useApi = () => {
    const errorsInterceptor = (res) => {
        switch (res?.data?.type) {
            case 'global_error':
                toaster.create({
                    description: res?.data?.value ?? 'SERVER_ERROR',
                    type: "error",
                })
                break;
            default:
                return res;
        }
    }

    if (!interceptorsRegistered) {

        /**
         * These are global error interceptors
         */
        http.interceptors.response.use(async response => {
            errorsInterceptor(response);
            document.dispatchEvent(new CustomEvent('authStorageChanged', {
                bubbles: true,
                detail: getStoredUser()
            }));
            return response
        }, async error => {
            errorsInterceptor(error?.response)
            document.dispatchEvent(new CustomEvent('authStorageChanged', {
                bubbles: true,
                detail: getStoredUser()
            }));
            return Promise.reject(error);
        });

        interceptorsRegistered = true;
    }

    return {
        ...services
    };
};
